'use strict';

(function () {
  'use strict';

  angular.module('msGoals').controller('GoalsCtrl', GoalsCtrl);

  GoalsCtrl.$inject = ['ModalService', 'goalSvc', 'NotifyingSvc', 'goalsList', 'userSvc'];

  /* @ngInject */
  function GoalsCtrl(ModalService, goalSvc, NotifyingSvc, goalsList, userSvc) {
    var vm = this;
    vm.goalsList = goalsList;
    vm.openEditGoalModal = openEditGoalModal;
    vm.appMode = 'STANDARD';

    activate();

    ///////////// Public Functions //////////////////

    function activate() {
      userSvc.getUser().then(function (user) {
        vm.user = user;
        vm.appMode = vm.user && vm.user.accessCode && vm.user.accessCode.applicationMode ? vm.user.accessCode.applicationMode.name : 'STANDARD';
      });
      // Fetch goals and habit responses
      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.GOALS_UPDATED, function () {
        goalSvc.fetchGoalsAndHabits().then(function (resp) {

          // For plotting consistency, title = name.
          resp.forEach(function (goal) {
            goal.sections.forEach(function (habit) {
              habit.title = habit.name;
            });
          });

          vm.goalsList = resp;
        });
      });
      vm.title = 'GoalsHabitsCtrl';
    }

    function openEditGoalModal(stepToStartAt, goal) {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
        templateUrl: 'goals/templates/create-new-goal-modal.html',
        controller: 'EditGoalCtrl',
        inputs: {
          step: stepToStartAt,
          goal: goal,
          editMode: false
        }
      });
    }
  }
})();